export enum UploadTypes {
  File = 1,
  Hyperlink = 2,
}
